import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { buildHelpers } from "./lib/catalog";

export const API_BASE = process.env.REACT_APP_BACKEND_URL;

const DataContext = createContext(null);

export function DataProvider({ children }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE}/api/bootstrap`)
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then(setData)
      .catch((e) => setError(e.message));
  }, []);

  const value = useMemo(() => {
    if (!data) return null;
    return { ...data, ...buildHelpers(data) };
  }, [data]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="data-error">
        <div className="text-center px-6">
          <div className="text-[#0a2a5e] font-black text-xl mb-2">Unable to load</div>
          <p className="text-sm text-slate-500 mb-4">Please check your connection and try again.</p>
          <button onClick={() => window.location.reload()} className="text-sm font-semibold text-white bg-[#0a2a5e] rounded-full px-5 py-2">Retry</button>
        </div>
      </div>
    );
  }

  if (!value) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white" data-testid="data-loading">
        <img src="/baishalii-logo.png" alt="BAISHALII" className="h-16 w-auto animate-pulse" />
      </div>
    );
  }

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
}

export const useData = () => useContext(DataContext);
